import { Directive, ElementRef, HostListener, Input } from '@angular/core';

// Image de secours quand l'URL d'origine ne répond plus : <img [src]="logo" [appImgFallback]="logoEnBase">
// (ex. logo d'un annonceur, dont PromoDeep garde une copie en base).
@Directive({
    selector: 'img[appImgFallback]',
    standalone: false
})
export class ImgFallbackDirective {

  @Input() appImgFallback: string | null | undefined;

  constructor(private element: ElementRef<HTMLImageElement>) { }

  @HostListener('error')
  onError(): void {
    const img = this.element.nativeElement;
    // Une seule tentative, pour ne pas boucler si la copie est elle aussi indisponible
    if (this.appImgFallback && img.getAttribute('src') !== this.appImgFallback) {
      img.src = this.appImgFallback;
      return;
    }
    // Aucune image utilisable : on la masque plutôt que d'afficher l'icône d'image cassée
    img.style.display = 'none';
  }

  // Nouvelle image (ex. autre aperçu) : de nouveau visible
  @HostListener('load')
  onLoad(): void {
    this.element.nativeElement.style.display = '';
  }
}
